import React, { Component } from 'react'
import {
    Form, FormGroup, Label, Input, Button, Progress
} from 'reactstrap'
import Archivo from '../../../utilitarios/archivo'
const archivo = new Archivo

export default class NuevoArchivo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null,
            desrcipcion: '',
            ImgProgress: 0
        }
        this.guardarArchivo = this.guardarArchivo.bind(this)
        this.onChange = this.onChange.bind(this)
        this.onChangeImg = this.onChangeImg.bind(this)
        this.actualizarImgProgress = this.actualizarImgProgress.bind(this)
    }

    guardarArchivo(e) {
        e.preventDefault()
        archivo.guardarFile(this.state.file, this.state.desrcipcion, this.actualizarImgProgress)
            .then(url => {
                archivo.Descripcion = this.state.desrcipcion
                archivo.Fecha = new Date
                archivo.Link = url
                archivo.guardar(archivo).then(this.props.archivoGuardado)
            })
    }

    onChange(e) {
        this.setState({
            desrcipcion: e.target.value
        })
    }

    onChangeImg(e) {
        const file = e.target.files[0]
        this.setState({
            file
        })
    }

    actualizarImgProgress(ImgProgress) {
        this.setState({
            ImgProgress
        })
    }

    render() {
        return (
            <div>
                <Form onSubmit={this.guardarArchivo}>
                    <FormGroup>
                        <Label for="Descripcion">Descripción</Label>
                        <Input onChange={this.onChange} type="text" id="Descripcion" placeholder="Descripción" required />
                    </FormGroup>
                    <FormGroup>
                        <Input onChange={this.onChangeImg} className="btn btn-outline-dark btn-sm" type="file" name="file" id="Img" />
                        {
                            this.state.ImgProgress > 0 && <Progress id="ImgProgress" animated color="warning" value={this.state.ImgProgress} />
                        }
                    </FormGroup>
                    <Button color="success">Guardar</Button>
                </Form>
            </div>
        )
    }
}